import {FluxoSelect} from './fluxo/fluxo-select-model';
import { GrupoSelect } from './grupo/grupo-select.model';
import { Usuario } from './usuario/usuario.model';
import {Setor} from './setor/setor.model';
import {CanalOrigemContatoEnum} from './../enum/canal-origem-contato.enum';

export class Conta {
  id?: number;
  nome?: string;
  numero?: string;
  ativo?: boolean;
  whatsappBussinesId?: string;
  numeroMetaId?: string;
  aplicativoId?: string;
  canalOrigem?: CanalOrigemContatoEnum;
  dataCriacao?: Date;
  dataAlteracao?: Date;
  usuarioCriacao?: Usuario;
  usuarioAlteracao?: Usuario;
  fluxo?: FluxoSelect;
  grupo?: GrupoSelect;
  setor?: Setor[];

  redirectUri?: string;
  username?: string;
  profilePictureUrl?: string;
  accountType?: string;
  tokenExpiraEm?: Date;
  ultimoWebhookRecebidoEm?: Date;
  conectado?: boolean;
}
